import { render } from "./BOA.vue?vue&type=template&id=2e44857f"
import script from "./BOA.vue?vue&type=script&lang=js"
export * from "./BOA.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/ZTDisk/Mx_Zone/projects/xs/labfront/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__